import session from '@/shared/session'
import { mapState } from 'vuex';

// initial state
const state = {
	current : {},
}

// getters
const getters = {}
// actions
const actions = {
	subscriptionOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/subscriptions/subscriptions/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	subscriptionDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/subscriptions/subscriptions/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	subscriptionCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/subscriptions/subscriptions/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	subscriptionUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/subscriptions/subscriptions/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	subscriptionRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/subscriptions/subscriptions/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterSubscription ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/subscriptions/subscriptions/get_filtered_subscription/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    subscriptionStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/subscriptions/subscriptions/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
